import React from "react";
import { API_URL } from "../config/index";

import "./Stripe.css";

const Stripe = () => {
  return (
    <section className="section">
      <div className="divwoocommerce">
        <div className="formmargin">
          <div className="formG">
            <div className="frame-parent">
              <div className="cell-parent">
                <div className="cell" />
                <div className="cell1">
                  <b className="product">Product</b>
                  <button className="cell2">
                    <b className="stripe-price">Price</b>
                  </button>
                </div>
              </div>
              <button className="cell3">
                <b className="subtotal">Subtotal</b>
              </button>
            </div>
            <div className="stripe-body">
              <div className="row">
                <div className="data">
                  <div className="stripe-data">$19.99</div>
                </div>
                <div className="data1">
                  <div className="stripe-data">$19.99</div>
                </div>
                <div className="data2">
                  <img
                    className="logo-forex-miner-1-icon"
                    alt=""
                    src="/forexLogo_blackBackground.png"
                  />
                  <div className="formLink">
                    <div className="forex-miner-paid">
                      Forex Miner Paid Subscription
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="divcart-collateralsmargin">
          <div className="divcart-collaterals">
            <div className="cart-totals-wrapper">
              <h3 className="cart-totals">Cart totals</h3>
            </div>
            <div className="proceed-to-checkout-link">
              <div className="cart-footer">
                <div className="cell-footer">
                  <div className="total">Sub Total</div>
                  <b className="b">$19.99</b>
                </div>
              </div>
              <div className="cart-footer">
                <div className="cell-footer">
                  <div className="total">Total</div>
                  <b className="b">$19.99</b>
                </div>
              </div>
              <form
                action={`${API_URL}/api/stripe/create-checkout-session`}
                method="POST"
              >
                <button className="formLink1" type="submit">
                  <div className="proceed-to-checkout">Proceed to checkout</div>
                </button>
              </form>
            </div>
            <div className="formLink2" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stripe;
